module.exports = __webpack_public_path__ + "img/11pts1234.ebab009b.png";